<template>
  <button
    @click.prevent="$emit('click')"
    class="btn btn-outline-dark text-uppercase"
    :class="{
      'active': checked,
    }"
    type="button"
    id="btn-all-versions">
    <i
      :class="{
        'far': !checked,
        'fas': checked,
        'fa-circle': !checked,
        'fa-check-circle': checked,
      }"
    ></i>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "ToggleButton",
  props: {
    checked: Boolean,
    children: String,
  },
}
</script>

<style scoped>

</style>
